module.exports = __webpack_public_path__ + "static/media/live-course-banner.25fa6ca5.png";